import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';
import type { IUseCase } from '@/shared/contracts/use-case.contract';
import { atendimentoEndpoint, type AtendimentoCliente } from '../types';

type Input = { slug: string; phone: string };

// Procura o cliente pelo telefone (na loja e na base geral). null = não achou.
export class BuscarClienteTelefoneUseCase implements IUseCase<Input, AtendimentoCliente | null> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute({ slug, phone }: Input): Promise<AtendimentoCliente | null> {
    const response = await this.client.sendRequest<{ data: AtendimentoCliente | null }, never>({
      endpoint: `${atendimentoEndpoint(slug)}/clientes/telefone`,
      method: HttpMethod.GET,
      params: { phone },
    });

    return response.data ?? null;
  }
}
